import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { Host } from '@/api/bol';

export interface HostDeleteDialogProps {
  open: boolean;
  host: Host | null;
  onClose: () => void;
  onDelete: (hostName: string) => Promise<void>;
}

export const HostDeleteDialog: React.FC<HostDeleteDialogProps> = ({
  open,
  host,
  onClose,
  onDelete
}) => {
  const handleDelete = async () => {
    if (host?.name) {
      await onDelete(host.name);
    }
  };

  return (
    <DeleteConfirmDialog
      open={open}
      title="Delete Host"
      itemType="host"
      itemId={host?.name || null}
      onClose={onClose}
      onConfirm={handleDelete}
    />
  );
};